import { CircularProgress, CircularProgressProps, Stack, StackProps } from '@mui/material'
import React, { FC } from 'react'

interface DefaultLoaderProps {
  containerProps?: StackProps
  loaderProps?: CircularProgressProps
}

export const DefaultLoader: FC<DefaultLoaderProps> = ({ containerProps, loaderProps }) => {
  return (
    <Stack height="100%" alignItems="center" justifyContent="center" {...(containerProps || {})}>
      <CircularProgress {...(loaderProps || {})} />
    </Stack>
  )
}
